export enum ElasticSearchScopeFields{
  TrackOrderId= 'TrackOrderId',
  CorrelationId = 'CorrelationId',
}